import { render, staticRenderFns } from "./AnswerTicket.vue?vue&type=template&id=66b39dae"
import script from "./AnswerTicket.vue?vue&type=script&lang=js"
export * from "./AnswerTicket.vue?vue&type=script&lang=js"
import style0 from "./AnswerTicket.vue?vue&type=style&index=0&id=66b39dae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports